// Featured photos from the Kingdom of Plomari
// Artwork, book covers, and mystical imagery

export const featuredPhotos = [
  // Book Covers from A Love Letter To Humanity
  {
    url: "https://www.artsetfree.com/2025/TOP-TheMushroomSeamstress-BochSaga-ALoveLetterToHumanity-2025-4.jpg",
    title: "The Mushroom Seamstress",
    description: "Book cover from A Love Letter To Humanity series"
  },
  {
    url: "https://www.artsetfree.com/image/BookIntro_TheChymicalWeddingAtLast.jpg",
    title: "The Chymical Wedding",
    description: "The Pink Bible of Plomari"
  },
  {
    url: "https://www.artsetfree.com/image/BookIntro_TheCoganDynasty.jpg",
    title: "The Cogan Dynasty",
    description: "The royal story of the Cogan Family"
  },
  
  // Kingdom of Plomari Artwork (you can add more!)
  {
    url: "https://images.unsplash.com/photo-1518709414768-a88981a4515d?w=1200",
    title: "Golden Crown of Plomari",
    description: "Symbol of the eternal Kingdom"
  },
  {
    url: "https://images.unsplash.com/photo-1470790376778-a9fbc86d70e2?w=1200",
    title: "Mystical Forest",
    description: "Where the mushrooms grow in Plomari"
  },
  {
    url: "https://images.unsplash.com/photo-1419242902214-272b3f66ee7a?w=1200",
    title: "Starlit Paradise",
    description: "The night sky over the Kingdom of Plomari"
  },
  {
    url: "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=1200",
    title: "Mountain Sanctuary",
    description: "The eternal refuge of Plomari"
  },
  {
    url: "https://images.unsplash.com/photo-1475924156734-496f6cac6ec1?w=1200",
    title: "Sunset Kingdom",
    description: "Golden hour in the land of freedom"
  },
  {
    url: "https://images.unsplash.com/photo-1501139083538-0139583c060f?w=1200",
    title: "Magic Mushroom Path",
    description: "The sacred journey through Plomari"
  },
  {
    url: "https://images.unsplash.com/photo-1516339901601-2e1b62dc0c45?w=1200",
    title: "Cosmic Portal",
    description: "Gateway to the eternal Kingdom"
  },
  {
    url: "https://images.unsplash.com/photo-1464802686167-b939a6910659?w=1200",
    title: "Northern Lights",
    description: "The aurora of Plomari"
  },
  {
    url: "https://images.unsplash.com/photo-1477346611705-65d1883cee1e?w=1200",
    title: "Ocean of Eternity",
    description: "Breathe Plomari Eternity"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_fluent-artistry/artifacts/z36d22c7_17710642571253809858552028103247.jpg",
    title: "A Love Letter To Humanity",
    description: "The biggest production of all time - Flee from the one named Queen Cecilia Cogan"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_9ee52aff-2390-4c74-bcda-0a35006c058b/artifacts/yib7r8f2_PinkPalaceInTheClouds1-enhanced.jpg",
    title: "Pink Palace in the Clouds",
    description: "AI Art by King Spiros of Plomari"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_9ee52aff-2390-4c74-bcda-0a35006c058b/artifacts/9xk2tif5_MySong-WwwArtSetFreeCom.jpg",
    title: "My Song",
    description: "My Life in Plomari is a song - Break free!"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_9ee52aff-2390-4c74-bcda-0a35006c058b/artifacts/zptt5s1z_RelaxingInThePlomariPalace86-3-Enhanced-ArtSetFreeCom.jpg",
    title: "Relaxing in the Plomari Palace",
    description: "AI Art by King Spiros of Plomari"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_9ee52aff-2390-4c74-bcda-0a35006c058b/artifacts/mbn2p4e8_HeartOfPlomari-1.jpg",
    title: "Heart of Plomari",
    description: "The sacred heart pierced by love"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_9ee52aff-2390-4c74-bcda-0a35006c058b/artifacts/g6mnz8fm_IMG_20260209_044835.jpg",
    title: "Be Careful With Small Visions",
    description: "Wisdom from King Spiros of Plomari"
  }
];

// Function to get a random photo
export const getRandomPhoto = () => {
  const randomIndex = Math.floor(Math.random() * featuredPhotos.length);
  return featuredPhotos[randomIndex];
};
